import { create } from 'zustand'

interface VoucherState {
  code: string | null
  discount: number
  description: string
  set: (code: string, discount: number, description: string) => void
  clear: () => void
}

export const useVoucherStore = create<VoucherState>()((set) => ({
  code: null,
  discount: 0,
  description: '',
  set: (code, discount, description) => set({ code, discount, description }),
  clear: () => set({ code: null, discount: 0, description: '' }),
}))
